import styled from '@emotion/styled';
interface StyledButtonProps {
  primary?: boolean;
  large?: boolean;
  light?: boolean;
  rounded?: boolean;
}

const StyledButton = styled.button<StyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.blue._400};
  background-color: ${(props) => (props.primary ? props.theme.colors.yellow._400 : 'white')};
  border: none;
  font-family: Inter;
  font-weight: bold;
  font-size: 18px;
  height: ${(props) => (props.large ? '60px' : '40px')};
  width: 100%;
  padding: 0 ${(props) => (props.large ? '3em' : '2em')};
  outline-color: ${(props) => props.theme.colors.blue._100};
  -moz-outline-radius: unset;
  border-radius: ${(props) => (props.rounded ? '20px' : '0')};

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    width: auto;
  }

  img {
    margin-right: 5px;
  }

  &:hover {
    cursor: pointer;
    background-color: ${(props) => (props.light ? 'white' : props.theme.colors.blue._400)};
    color: ${(props) => (props.light ? props.theme.colors.blue._400 : 'white')};
  }
`;

export { StyledButton };
